import type { NotifyModelProps } from '@mail/3promo';
import type { ReactRendererComponent } from '@mail/3promo/render/react';
import React, { useRef } from 'react';
import { webpushConfig } from 'reactApp/appHelpers/featuresHelpers/features/webPush';
import { Button } from 'reactApp/ui/Button/Button';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './WebPushNotifyPromo.css';

interface WebPushTemplateData {}

const { text, primaryButtonText, secondaryButtonText } = webpushConfig.content;

const WebPushNotifyPromo: ReactRendererComponent<NotifyModelProps<WebPushTemplateData>> = ({ close, complete, snooze }) => {
    const targetRef = useRef<HTMLDivElement>(null);

    const handleAction = async () => {
        complete();

        if (window.__WP?.requestPermission) {
            window.__WP.requestPermission();
            return;
        }

        if ('Notification' in window) {
            try {
                await window.Notification.requestPermission();
            } catch {}
        }
    };

    const handlePostpone = () => {
        snooze();
    };

    return (
        <>
            <div className={styles.target} ref={targetRef} />
            <FloatingTooltip
                target={targetRef}
                placement={ETooltipPlacement.bottomStart}
                onClose={close}
                closeOnOutsideClick={false}
                hideArrow
                usePortal
                qaId="tooltip-webpush"
                className={styles.tooltip}
            >
                <div className={styles.content}>
                    <div className={styles.text}>{text}</div>
                    <div className={styles.buttons}>
                        <Button primary middle theme="octavius" onClick={handleAction}>
                            {primaryButtonText}
                        </Button>
                        <Button middle theme="octavius" onClick={handlePostpone}>
                            {secondaryButtonText}
                        </Button>
                    </div>
                </div>
            </FloatingTooltip>
        </>
    );
};

export { WebPushNotifyPromo };
export type { WebPushTemplateData };
